import React from "react";
import { FC } from "react";
import { NavLink } from "react-router-dom";

export interface CommonLayoutProps {
  children?: React.ReactNode;
  className?:string;
}

const CommonLayout: FC<CommonLayoutProps> = ({ children , className}) => {
  return (
    <div className="nc-CommonLayoutProps bg-neutral-50 dark:bg-neutral-900 w-full">
      <div className="border-b border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-800">
        <div className="container">
          <div className="flex space-x-8 md:space-x-14 overflow-x-auto hiddenScrollbar">
            <NavLink
              to="/account"
              className={({ isActive }) =>
                `block py-5 md:py-8 border-b-2 flex-shrink-0 ${
                  !isActive ? "border-transparent" : "custom-border-active"
                }`
              }
            >
              Update Profile
            </NavLink>
            {/* <NavLink
              to="/direktConnects"
              className={({ isActive }) =>
                `block py-5 md:py-8 border-b-2 flex-shrink-0 ${
                  !isActive ? "border-transparent" : "custom-border-active"
                }`
              }
            >
              DirektConnects
            </NavLink> */}
        
            {/* <NavLink
              to="/direktCoins"
              className={({ isActive }) =>
                `block py-5 md:py-8 border-b-2 flex-shrink-0 ${
                  !isActive ? "border-transparent" : "custom-border-active"
                }`
              }
            >
              DirektCoins
            </NavLink> */}
            <NavLink
              to="/blacklist"
              className={({ isActive }) =>
                `block py-5 md:py-8 border-b-2 flex-shrink-0 ${
                  !isActive ? "border-transparent" : "custom-border-active"
                }`
              }
            >
              Blacklist
            </NavLink>
            <NavLink
              to="/receipt-requests"
              className={({ isActive }) =>
                `block py-5 md:py-8 border-b-2 flex-shrink-0 ${
                  !isActive ? "border-transparent" : "custom-border-active"
                }`
              }
            >
              Receipt Requests
            </NavLink>
          </div>
        </div>
      </div>
      <div className="container pt-14 sm:pt-20 pb-24 lg:pb-32">{children}</div>
    </div>
  );
};

export default CommonLayout;
